import React, { useState, useEffect, useContext, useRef } from 'react';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import OptionRowFloat from 'components/layout_and_quote_builder/options/OptionRowFloat.jsx'
import LoadFromLocalStorage from 'components/layout_and_quote_builder/options/LoadFromLocalStorage.jsx'
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import Constants from 'components/layout_and_quote_builder/Constants.jsx'
import MyEventListener from 'components/common/MyEventListener.jsx'

 const ChooseLayoutDimensions = ({ index, title, item, hideMargins, hideCustom, publicSetter, defaultValues, smallerSubSetOf, disableMargins}) => {
  const myLayoutContext = useContext(LayoutContext);
  const [isEditMode, setIsEditMode] = useState(false);

  const [layout_dimension_id, set_layout_dimension_id] = useState( defaultValues["layout_dimension_id"] || myLayoutContext.layoutOptions.layout_dimension_id);
  const [layout_dimension_width, set_layout_dimension_width] = useState( defaultValues["layout_dimension_width"] || myLayoutContext.layoutOptions.layout_dimension_width);
  const [layout_dimension_height, set_layout_dimension_height] = useState(defaultValues["layout_dimension_height"] || myLayoutContext.layoutOptions.layout_dimension_height);

  const [layout_dimension_top_margin_diecutting, set_layout_dimension_top_margin_diecutting]       = useState(defaultValues["layout_dimension_top_margin"]    || myLayoutContext.layoutOptions.layout_dimension_top_margin);
  const [layout_dimension_side_margin_diecutting, set_layout_dimension_side_margin_diecutting]     = useState(defaultValues["layout_dimension_side_margin"]   || myLayoutContext.layoutOptions.layout_dimension_side_margin);
  const [layout_dimension_bottom_margin_diecutting, set_layout_dimension_bottom_margin_diecutting] = useState(defaultValues["layout_dimension_bottom_margin"] || myLayoutContext.layoutOptions.layout_dimension_bottom_margin);

  const [layout_dimension_top_margin_printing, set_layout_dimension_top_margin_printing]       = useState(defaultValues["layout_dimension_top_margin"]    || myLayoutContext.layoutOptions.layout_dimension_top_margin);
  const [layout_dimension_side_margin_printing, set_layout_dimension_side_margin_printing]     = useState(defaultValues["layout_dimension_side_margin"]   || myLayoutContext.layoutOptions.layout_dimension_side_margin);
  const [layout_dimension_bottom_margin_printing, set_layout_dimension_bottom_margin_printing] = useState(defaultValues["layout_dimension_bottom_margin"] || myLayoutContext.layoutOptions.layout_dimension_bottom_margin);

  const [layout_dimension_filtering_enabled, set_layout_dimension_filtering_enabled] = useState(defaultValues["layout_dimension_filtering_enabled"] !== undefined ? defaultValues["layout_dimension_filtering_enabled"] : true);

  // Temporary display state for immediate UI feedback
  const [temp_top_margin_diecutting, set_temp_top_margin_diecutting] = useState(layout_dimension_top_margin_diecutting);
  const [temp_side_margin_diecutting, set_temp_side_margin_diecutting] = useState(layout_dimension_side_margin_diecutting);
  const [temp_bottom_margin_diecutting, set_temp_bottom_margin_diecutting] = useState(layout_dimension_bottom_margin_diecutting);
  const [temp_top_margin_printing, set_temp_top_margin_printing] = useState(layout_dimension_top_margin_printing);
  const [temp_side_margin_printing, set_temp_side_margin_printing] = useState(layout_dimension_side_margin_printing);
  const [temp_bottom_margin_printing, set_temp_bottom_margin_printing] = useState(layout_dimension_bottom_margin_printing);

  const getSmallerSubSetOfValues = () => {
    if(smallerSubSetOf == undefined) { return [ ] }
    const res = [];
    var width = 0
    var height = 0

    for (let [key, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      for(let i=0; i < values.length; i++) {

        if(values[i].id == smallerSubSetOf) {
          width = values[i].width
          height = values[i].height
        }
      }
    }

    return [width, height]
  }

  const correct = (value) => {
    var close = 0.05;
    if( Math.abs( Math.ceil(value) - value ) < close ) { return true }
    if( Math.abs( Math.floor(value) - value ) < close ) { return true }

    return false
  }

  const getSmallerSubSetOfIds = () => {
    if(smallerSubSetOf == undefined) {
      return []
    }

    let smallerSubSetOfValues = getSmallerSubSetOfValues()
    const w = smallerSubSetOfValues[0];
    const h = smallerSubSetOfValues[1];
    var res = []

    for (let [key, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      for(let i=0; i < values.length; i++) {
        let value = values[i];
        let w_part = w / value.width;
        let h_part = h / value.height;
        if( w_part > 0.99 && h_part > 0.99 && correct(w_part) && correct(h_part) ) {
          res.push(value.id)
        }
      }
    }
    return res
  }

  const layoutDimensionOptions = () => {
    let results = []
    let smallerSubSetOfListIds = getSmallerSubSetOfIds()

    var selectedValues = []

    for (let [key, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      // Sort values alphabetically by description
      let sortedValues = [...values].sort((a, b) => {
        return a.description.localeCompare(b.description);
      });

      // Reverse the order if key is "Other sizes"
      if (key === "Other sizes") {
        sortedValues = sortedValues.reverse();
      }

      results.push(
        <optgroup label={key} key={key}>
          {sortedValues.map((value) => {

            if(smallerSubSetOfListIds.length > 0) {
              if(smallerSubSetOfListIds.includes(value.id)) {
                 return <option key={value.id} value={value.id}> {value.description} </option>
              }
            } else {
              return <option key={value.id} value={value.id}> {value.description} </option>
            }
          })}

        </optgroup>
      )
    }

    if (!hideCustom) {
      results.push(
        <optgroup label={window.wording_choose_manual_dimensions} key="custom">
          <option value="custom" key="custom">
            {window.wording_enter_custom_material}
          </option>
        </optgroup>
      )
    }

    return results;
  }

  const formatValue = (value) => {
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(layout_dimension_unit == 'in' ? 4 : 2);
    return formatted
  }

  // Simple onChange handlers that update temp state immediately
  const handleTopMarginDiecutting = (value) => set_temp_top_margin_diecutting(value);
  const handleSideMarginDiecutting = (value) => set_temp_side_margin_diecutting(value);
  const handleBottomMarginDiecutting = (value) => set_temp_bottom_margin_diecutting(value);
  const handleTopMarginPrinting = (value) => set_temp_top_margin_printing(value);
  const handleSideMarginPrinting = (value) => set_temp_side_margin_printing(value);
  const handleBottomMarginPrinting = (value) => set_temp_bottom_margin_printing(value);

  // Edit/Save handler
  const handleEditSave = (e) => {
    e.preventDefault();
    if (isEditMode) {
      // Save mode: Update all permanent states
      set_layout_dimension_top_margin_diecutting(temp_top_margin_diecutting);
      set_layout_dimension_side_margin_diecutting(temp_side_margin_diecutting);
      set_layout_dimension_bottom_margin_diecutting(temp_bottom_margin_diecutting);
      set_layout_dimension_top_margin_printing(temp_top_margin_printing);
      set_layout_dimension_side_margin_printing(temp_side_margin_printing);
      set_layout_dimension_bottom_margin_printing(temp_bottom_margin_printing);
      setIsEditMode(false);
    } else {
      // Edit mode: Enable fields
      setIsEditMode(true);
    }
  };

  const onSolutionSet = (msg) => {
    if(msg.detail.index != index) { return }

    let diecutting_result = msg.detail.solution.diecutting_result
    let printing_result = diecutting_result.printing_result

    console.log( "-------------onSolutionSet------------------------" );

    // Exit edit mode since backend is providing new values
    setIsEditMode(false);

    const topDiecutting = formatValue(diecutting_result.user_margin_top);
    const sideDiecutting = formatValue(diecutting_result.user_margin_side);
    const bottomDiecutting = formatValue(diecutting_result.user_margin_bottom);
    const topPrinting = formatValue(printing_result.margins.user_margin_top);
    const sidePrinting = formatValue(printing_result.margins.user_margin_side);
    const bottomPrinting = formatValue(printing_result.margins.user_margin_bottom);

    // Update both permanent and temp states
    set_layout_dimension_top_margin_diecutting(topDiecutting);
    set_layout_dimension_side_margin_diecutting(sideDiecutting);
    set_layout_dimension_bottom_margin_diecutting(bottomDiecutting);
    set_layout_dimension_top_margin_printing(topPrinting);
    set_layout_dimension_side_margin_printing(sidePrinting);
    set_layout_dimension_bottom_margin_printing(bottomPrinting);

    set_temp_top_margin_diecutting(topDiecutting);
    set_temp_side_margin_diecutting(sideDiecutting);
    set_temp_bottom_margin_diecutting(bottomDiecutting);
    set_temp_top_margin_printing(topPrinting);
    set_temp_side_margin_printing(sidePrinting);
    set_temp_bottom_margin_printing(bottomPrinting);
  }

  const layout_dimension_unit = myLayoutContext.layoutOptions.layout_dimension_unit;
  const getPublicData = () => {
    return {
      layout_dimension_id,
      layout_dimension_unit,
      // layout_dimension_width,
      // layout_dimension_height,
      layout_dimension_top_margin_diecutting,
      layout_dimension_side_margin_diecutting,
      layout_dimension_bottom_margin_diecutting,
      layout_dimension_top_margin_printing,
      layout_dimension_side_margin_printing,
      layout_dimension_bottom_margin_printing,
      layout_dimension_filtering_enabled,
    }
  }

  const setPublicData = () => { publicSetter( () => getPublicData() ) }
  const dimensionIdSetter = (value) => { set_layout_dimension_id( () => value > 0 ? value : 1 ) }

  // Determine if fields should be disabled
  const fieldsDisabled = !isEditMode || disableMargins;

  useEffect(() => LoadFromLocalStorage(item, 'layout_dimension_id', dimensionIdSetter), []);

  if(publicSetter != undefined) {
    useEffect( setPublicData, [
      layout_dimension_id,
      layout_dimension_unit,
      // layout_dimension_width,
      // layout_dimension_height,
      layout_dimension_top_margin_diecutting,
      layout_dimension_side_margin_diecutting,
      layout_dimension_bottom_margin_diecutting,
      layout_dimension_top_margin_printing,
      layout_dimension_side_margin_printing,
      layout_dimension_bottom_margin_printing,
      layout_dimension_filtering_enabled,
    ])
  }

  useEffect( () => {
    emitEvent(Constants.layout_dimension_changed, {
      index: index,
    })
  }, [layout_dimension_id])

  // Sync temporary state with permanent state when permanent state changes externally
  useEffect(() => { set_temp_top_margin_diecutting(layout_dimension_top_margin_diecutting); }, [layout_dimension_top_margin_diecutting]);
  useEffect(() => { set_temp_side_margin_diecutting(layout_dimension_side_margin_diecutting); }, [layout_dimension_side_margin_diecutting]);
  useEffect(() => { set_temp_bottom_margin_diecutting(layout_dimension_bottom_margin_diecutting); }, [layout_dimension_bottom_margin_diecutting]);
  useEffect(() => { set_temp_top_margin_printing(layout_dimension_top_margin_printing); }, [layout_dimension_top_margin_printing]);
  useEffect(() => { set_temp_side_margin_printing(layout_dimension_side_margin_printing); }, [layout_dimension_side_margin_printing]);
  useEffect(() => { set_temp_bottom_margin_printing(layout_dimension_bottom_margin_printing); }, [layout_dimension_bottom_margin_printing]);

  MyEventListener( [{
    key: 'quote_builder.solution_set',
    callback: onSolutionSet
  }] )

  const select = () => {
    return (
      <table className="table" style={{marginBottom: '0'}}>
        <tbody>
          <tr>
            <td> {title != undefined ? title : window.wording_layouts_choose_dimensions} </td>
            <td>
               <select readOnly={window.user_quote_finalised} value={layout_dimension_id} className="form-control input_use_local_storage" name="layout_dimension_id" onChange={(e) => set_layout_dimension_id(e.target.value)} >
                {layoutDimensionOptions().map((value) => {
                  return value;
                }) }
              </select>
            </td>
          </tr>
        </tbody>
      </table>);
  }

  return (<>
  <div >

    <input type="hidden" value={layout_dimension_unit} name="layout_dimension_unit"/>
    <table className="table  table-bordered">
      <tbody>
        <tr>
          <td colSpan="2"> &nbsp; </td>
          <td>
            {select()}
          </td>
        </tr>

        <tr>

          <td>
            { !hideMargins &&
            <OptionRowFloat description={t('layouts.top_margin_diecutting')}
              item={item}
              name="layout_dimension_top_margin_diecutting"
              value={temp_top_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleTopMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>
          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.side_margin_diecutting')}
              item={item}
              name="layout_dimension_side_margin_diecutting"
              value={temp_side_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleSideMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>

          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.bottom_margin_diecutting')}
              item={item}
              name="layout_dimension_bottom_margin_diecutting"
              value={temp_bottom_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleBottomMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>

        </tr>

        <tr>
          <td>
            { !hideMargins &&
            <OptionRowFloat description={t('layouts.top_margin_printing')}
              item={item}
              name="layout_dimension_top_margin_printing"
              value={temp_top_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleTopMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>
          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.side_margin_printing')}
              item={item}
              name="layout_dimension_side_margin_printing"
              value={temp_side_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleSideMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>

          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.bottom_margin_printing')}
              item={item}
              name="layout_dimension_bottom_margin_printing"
              value={temp_bottom_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleBottomMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>

        </tr>

        { !hideMargins && (
          <tr>
            <td colSpan="3" style={{paddingTop: '0px', paddingBottom: '20px', textAlign: 'right'}}>
              <a
                href="#"
                onClick={handleEditSave}
                style={{
                  pointerEvents: disableMargins ? 'none' : 'auto',
                  opacity: disableMargins ? 0.5 : 1,
                  cursor: disableMargins ? 'not-allowed' : 'pointer',
                  textDecoration: 'none',
                }}
              >
                {!isEditMode && <>  <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit margins </>}
                {isEditMode && <> <i className="fa fa-floppy-o" aria-hidden="true"></i> Save margins </>}
              </a>
            </td>
          </tr>
        )}

        <tr>
          <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
            <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
              <input
                type="checkbox"
                checked={layout_dimension_filtering_enabled}
                onChange={(e) => set_layout_dimension_filtering_enabled(e.target.checked)}
                style={{marginRight: '8px'}}
              />
              <span>Cözüm Filtreleme</span>
            </label>
          </td>
        </tr>

      </tbody>
    </table>

    {layout_dimension_id == 'custom' && (<>
      <OptionRowFloat description={window.wording_layouts_width}
        item={item}
        name="layout_dimension_width"
        value={layout_dimension_width}
        unit={myLayoutContext.unit}
        onChange={set_layout_dimension_width}
      />

      <OptionRowFloat description={window.wording_layouts_height}
        item={item}
        name="layout_dimension_height"
        value={layout_dimension_height}
        unit={myLayoutContext.unit}
        onChange={set_layout_dimension_height}
      />
      </>)}

    </div>
    <div style={{'clear': 'both' }} ></div>
  </>)
}

export default ChooseLayoutDimensions;
